import React from 'react';
import classNames from 'classnames';

import styles from './Banner.module.scss';

export const bannerVariants = {
  info: 'info',
  warning: 'warning',
};

// Full-width notice pinned to the top of the main content area. Purely
// presentational: callers decide when to render it and what goes inside.
export const BannerComponent = ({
  variant = bannerVariants.info,
  icon,
  title,
  children,
  actions,
  onClose,
  className,
}) => (
  <div
    className={classNames(
      styles.banner,
      { [styles[`banner_variant_${variant}`]]: variant },
      className
    )}
  >
    <div className={styles.content}>
      {icon && <span className={styles.icon}>{icon}</span>}
      {title && <span className={styles.title}>{title}</span>}
      {children && <span className={styles.message}>{children}</span>}
    </div>
    {(actions || onClose) && (
      <div className={styles.actions}>
        {actions}
        {onClose && (
          <button
            type="button"
            className={styles.closeButton}
            onClick={onClose}
            title="Close banner"
          >
            ×
          </button>
        )}
      </div>
    )}
  </div>
);

BannerComponent.displayName = 'Banner';
